import React from 'react';
import LabelRules from './LabelRules';

export default (props) => <LabelRules {...props} />;
